import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { DstLiveTable } from "../../components/DstTable/DstLiveTable";
import ListerSearch from "../../components/Lister/ListerSearch/ListerSearch";
import { useSession } from "../../contexts/SessionContext";
import { formatDateHumanly } from "../../services/TimeService";
import translate from "../../services/Translate";
import { completeNavigate } from "../../services/UtilityService";
import { generateRemoteUrl } from "./Courses.function";

export const Courses = () => {
  const { language } = useSession();
  const [searchQuery, setSearchQuery] = useState<string>("");
  const navigate = useNavigate();

  const columns = [
    { name: translate(language, "PAGES.COURSES.ID"), key: "id", sortable: true },
    { name: translate(language, "PAGES.COURSES.NAME"), key: "name", sortable: true },
    { name: translate(language, "PAGES.COURSES.DESCRIPTION"), key: "description" },
    {
      name: translate(language, "PAGES.COURSES.STAGES_COUNT"),
      key: "stages_count",
      render: (item: any) => <span>{item.stages_count}</span>,
    },
    { name: translate(language, "PAGES.COURSES.COURSES_OWNER"), key: "owner_full_name" },
    { name: translate(language, "PAGES.COURSES.COURSES_AUTHOR"), key: "author_full_name" },
    {
      name: translate(language, "PAGES.COURSES.START_DATE"),
      key: "dt_created",
      sortable: true,
      render: (item: any) => (
        <span title={formatDateHumanly(language, item.dt_created, true)}>
          {formatDateHumanly(language, item.dt_created)}
        </span>
      ),
    },
    {
      name: translate(language, "PAGES.COURSES.UPDATED_DATE"),
      key: "dt_updated",
      sortable: true,
      render: (item: any) =>
        item?.dt_updated ? (
          <span title={formatDateHumanly(language, item.dt_updated, true)}>
            {formatDateHumanly(language, item.dt_updated)}
          </span>
        ) : (
          <span>-</span>
        ),
    },
  ];

  return (
    <div className="m-5">
      <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
        <h2 className="mb-0">{translate(language, "PAGES.COURSES.TITLE")}</h2>
        <ListerSearch setSearchQuery={setSearchQuery} timeDelay={500} showSearchIcon />
      </div>
      <DstLiveTable
        classTable="text-nowrap"
        remote={generateRemoteUrl(searchQuery)}
        remoteKey="cursus"
        columns={columns}
        pagination
        paginationAlwaysShowFooter
        paginationResizeOptions={[10, 50, 100]}
        onRowClick={(event, item) => completeNavigate(event, navigate, `/course/${item.id}`)}
      />
    </div>
  );
};

export default Courses;
